import { gql } from "@apollo/client";

const GET_MAGENTO_TEMP_PRODUCT_LIST = gql`
  query getTempMagentoProductList($input: GetListInput) {
    getTempMagentoProductList(input: $input) {
      data {
        count
        tempProductList {
          _id
          name
          image
          isShopifySync
          isSynced
          providerIds
          storeProductId
          status
          updatedAt
          createdAt
        }
      }
      error
      status
    }
  }
`;

export default GET_MAGENTO_TEMP_PRODUCT_LIST;
